const MesureAcceptStyle = {
  bg: "white",
};

export { MesureAcceptStyle };
